import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import {
  distinctUntilChanged,
  filter,
  map,
  mergeMap,
  tap,
} from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { Organisation } from '../../organisation/organisation.interface';
import { organisationById } from '../../organisation/organisation.selector';
import {
  loadOrganisationById,
  setCurrentOrganisationID,
} from '../../organisation/organisation.actions';
import { ShapeService } from '../../element-editor/shape/shape.service';

@Component({
  selector: 'nw-organisation-index',
  templateUrl: './organisation-index.component.html',
  styleUrls: ['./organisation-index.component.scss'],
})
export class OrganisationIndexComponent {
  readonly organisationId$: Observable<string>;
  readonly organisation$: Observable<Organisation>;

  mode: undefined | 'users' | 'settings';

  get isProjectsMode() {
    return !this.mode;
  }

  get isUsersMode() {
    return this.mode == 'users';
  }

  get isSettingsMode() {
    return this.mode == 'settings';
  }

  orgId: string;

  constructor(
    private readonly route: ActivatedRoute,
    private readonly store: Store,
    private router: Router,
    private readonly shapeService: ShapeService,
  ) {
    this.router.events.subscribe(() => {
      // Get the current path after '/organisation'
      const fullPath = this.router.url;
      const segments = fullPath.split('/');

      const last = segments[segments.length - 1];

      if (last == 'users') {
        this.mode = 'users';
      } else if (last == 'settings') {
        this.mode = 'settings';
      } else {
        this.mode = undefined;
      }
    });

    this.organisationId$ = this.route.params.pipe(
      map(({ organisationID }) => organisationID),
      filter(id => !!id),
    );

    this.organisation$ = this.organisationId$.pipe(
      distinctUntilChanged(),
      tap(id => {
        this.orgId = id;
        this.store.dispatch(setCurrentOrganisationID({ ID: id }));
        this.store.dispatch(loadOrganisationById({ id }));
      }),
      mergeMap(id => this.store.select(organisationById(id))),
    );
    console.warn('org-index-comp');
  }
  exit() {}
  selectMode(mode?: 'users' | 'settings') {
    this.shapeService.navigateToOrgIndex(mode, this.orgId);
  }
}
